var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({
    'padding-top': _vm.paddingTop + 'px',
    'padding-bottom': _vm.paddingBottom + 'px',
    'background-color': _vm.useBackgroundColor
  })},[_c('div',{class:{ 'container': _vm.useContainer, 'redirect-block-select': _vm.blockParams?.isUrl },on:{"click":function($event){return _vm.$emit('block:redirect')}}},[_c('div',{staticClass:"about-cover"},[_c('ui-image',{attrs:{"file-data":{ fileId: _vm.mainFields?.image?.value },"loading":"eager"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }